import React from 'react';
import {
  IonPage,
  IonContent,
  IonGrid,
  IonList,
  IonItem,
  IonLabel,
  IonSelect,
  IonSelectOption
} from '@ionic/react';
import WithRecords from 'src/components/WithRecords';
import DefaultHeader from 'src/components/DefaultHeader';
import { convert, startOf, endOf, subtract } from 'src/lib/time';
import { printNumber } from 'src/lib';
import {
  DatesGraph,
  TotalsGraph,
  PerStageTypeGraph,
  ScheduledTimeDiffGraph
} from 'src/components/StatsGraphs';

class Stats extends React.Component {
  state = {
    selected: 'thisWeek'
  };

  options = {
    today: () => ({
      $gt: startOf('day'),
      $lt: endOf('day')
    }),
    thisWeek: () => ({
      $gt: startOf('week'),
      $lt: endOf('week')
    }),
    thisMonth: () => ({
      $gt: startOf('month'),
      $lt: endOf('month')
    }),
    lastWeek: () => ({
      $gt: startOf('week', subtract(new Date(), 1, 'weeks')),
      $lt: endOf('week', subtract(new Date(), 1, 'weeks'))
    }),
    lastMonth: () => ({
      $gt: startOf('month', subtract(new Date(), 1, 'months')),
      $lt: endOf('month', subtract(new Date(), 1, 'months'))
    }),
    allTime: () => 'allTime'
  };

  handleDateChange = (event) => {
    const selected = event.target.value;
    this.setState({ selected });
    if (selected !== 'allTime') {
      this.props.setQuery(
        { ...this.props.query, scheduled_time: this.options[selected]() },
        this.props.search
      );
    } else {
      const newQuery = { ...this.props.query };
      delete newQuery.scheduled_time;
      this.props.setQuery(newQuery, this.props.search);
    }
  };

  render() {
    const { fetching, query } = this.props;
    const { selected } = this.state;
    const {
      jobs,
      totals,
      dates,
      per_stage_type,
      scheduled_time_diff
    } = this.props.resources;
    return (
      <IonPage style={fetching ? { opacity: 0.75, clickEvents: 'none' } : {}}>
        <DefaultHeader title="My Stats" />
        <IonContent>
          <IonGrid fixed>
            {/* <div
              className="ion-padding"
              style={{ zIndex: 100, backgroundColor: '#f9f9f9' }}
            > */}
            <IonList>
              <IonItem lines="full">
                <IonLabel>Date Range:</IonLabel>
                <IonSelect
                  value={selected}
                  // interface="action-sheet"
                  okText="Okay"
                  cancelText="Dismiss"
                  onIonChange={this.handleDateChange}
                >
                  <IonSelectOption value="today">Today</IonSelectOption>
                  <IonSelectOption value="thisWeek">This Week</IonSelectOption>
                  <IonSelectOption value="thisMonth">
                    This Month
                  </IonSelectOption>
                  <IonSelectOption value="lastWeek">Last Week</IonSelectOption>
                  <IonSelectOption value="lastMonth">
                    Last Month
                  </IonSelectOption>
                  <IonSelectOption value="allTime">All Time</IonSelectOption>
                </IonSelect>
              </IonItem>
              {/* </div> */}
              <IonItem lines="full">
                <IonLabel slot="start">Worked Hours:</IonLabel>
                <IonLabel slot="end" className="ion-text-right">
                  <ion-text color="primary">
                    {printNumber(convert(totals.work_time, 'hours'))}
                  </ion-text>
                </IonLabel>
              </IonItem>
              <IonItem lines="full">
                <IonLabel slot="start">Break Hours:</IonLabel>
                <IonLabel slot="end" className="ion-text-right">
                  <ion-text color="primary">
                    {printNumber(convert(totals.break_time, 'hours'))}
                  </ion-text>
                </IonLabel>
              </IonItem>
              <IonItem lines="full">
                <IonLabel slot="start">Total Hours:</IonLabel>
                <IonLabel slot="end" className="ion-text-right">
                  <ion-text color="primary">
                    {printNumber(convert(totals.actual_time, 'hours'))}
                  </ion-text>
                </IonLabel>
              </IonItem>
              <IonItem lines="full">
                <IonLabel slot="start">Total Jobs Completed:</IonLabel>
                <IonLabel slot="end" className="ion-text-right">
                  <ion-text color="primary">
                    {printNumber(jobs.length, 0)}
                  </ion-text>
                </IonLabel>
              </IonItem>
            </IonList>
            <div className="ion-padding">
              {query.scheduled_time && (
                <div className="mt-3 mb-5">
                  <DatesGraph dates={dates} />
                </div>
              )}
              <div className="mb-5">
                <TotalsGraph totals={totals} />
              </div>
              <div className="mb-5">
                <PerStageTypeGraph perStageType={per_stage_type} />
              </div>
              <div className="mb-5">
                <ScheduledTimeDiffGraph
                  scheduledTimeDiff={scheduled_time_diff}
                />
              </div>
            </div>
          </IonGrid>
        </IonContent>
      </IonPage>
    );
  }
}

export default (routerProps) => {
  return (
    <WithRecords
      useLifecycle={true}
      service="api/job-stats"
      defaultQuery={{
        scheduled_time: {
          $gte: startOf('week'),
          $lte: endOf('week')
        }
      }}
      render={(withRecordsProps) => (
        <Stats {...withRecordsProps} {...routerProps} />
      )}
    />
  );
};
